// import UIMain from "./component/index";
// import H5UI from "./H5component/index";
import { isMobile } from "./common/Utils";
export default class VhallInterface {
  constructor(param) {
    this.vhallplayer = param.vhallplayer;
    window.vp = this.vhallplayer
    this.isLive = param.isLive;
    this.videoNode = param.videoNode;
    this.isLimitSeek = false;   // 是否开启seek限制
    this.limitSeekMax = 0;  // seek限制的最大值
    this.vhallplayer.on('seeked', res => {
      if (this.isLimitSeek) {
        const seekMax = this.vhallplayer.getPlayed().length >= 1 ? Math.max(this.limitSeekMax, this.vhallplayer.getPlayed().end(this.vhallplayer.getPlayed().length - 1)) : this.isLimitSeek;    // seek的最大限制
        if (this.vhallplayer.getCurrentTime() > seekMax) {
          this.vhallplayer.setCurrentTime(seekMax);
        }
      }
    });


    if (!isMobile()) {
      const UIMain = require("./component/index").default;
      new UIMain(this.videoNode, this);
    } else {
      const H5UI = require("./H5component/index").default;
      new H5UI(this.videoNode, this);
    }
  }

  /**
   * 事件监听
   * @param {string} eventName 事件名
   * @param {function} handler 处理函数
   */
  on(eventName, handler) {
    this.vhallplayer.on(eventName, handler);
  }

  /**
   * 播放
   */
  play() {
    this.vhallplayer.play();
  }

  /**
   * 暂停
   */
  pause() {
    this.vhallplayer.pause();
  }

  /**
   * 获取当前暂停状态
   */
  getIsPause() {
    return this.vhallplayer.getIsPaused();
  }

  /**
   * 获取循环状态
   * @param {function} failure 失败回调
   */
  getLoop(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    return this.vhallplayer.getLoop();
  }

  /**
   * 设置循环
   * @param {boolean} isLoop 是否循环
   * @param {function} failure 失败回调
   */
  setLoop(isLoop, failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    if (typeof isLoop !== "boolean") {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    this.vhallplayer.setLoop(isLoop);
  }

  /**
   * 获取视频清晰度列表
   * @return {Array} 视频清晰度
   */
  getQualitys() {
    return this.vhallplayer.currentDefinitionList;
  }

  /**
   * 获取当前视频清晰度
   */
  getCurrentQuality() {
    return this.vhallplayer.currentDefinition;
  }

  /**
   * 设置当前视频清晰度
   * @param {object} obj 清晰度对象
   * @param {function} failure 失败回调
   */
  setQuality(obj, failure) {
    if (Object.prototype.toString.call(obj) !== '[object Object]') {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    this.vhallplayer.currentDefinition = obj;
  }

  /**
   * 进入全屏
   * @param {function} failure 失败回调
   */
  enterFullScreen(failure) {
    if (this.vhallplayer.isFullscreen) {
      failure && failure({ code: '611005', message: "进入全屏失败", data: {} });
      return;
    }
    this.vhallplayer.enterFullscreen();
  }

  /**
   * 退出全屏
   * @param {function} failure 失败回调
   */
  exitFullScreen(failure) {
    if (!this.vhallplayer.isFullscreen) {
      failure && failure({ code: '611006', message: "退出全屏失败", data: {} });
      return;
    }
    this.vhallplayer.exitFullscreen();
  }

  /**
   * 获取当前是否是全屏
   */
  isFullscreen() {
    return this.vhallplayer.isFullscreen;
  }

  /**
   * 设置静音
   * @param {boolean} isMute 是否静音 
   * @param {function} failure 失败回调
   */
  setMute(isMute, failure) {
    if (typeof isMute !== "boolean") {
      failure && failure({ code: '611001', message: "无效的参数", data: {} })
      return;
    }
    this.vhallplayer.setMuted(isMute);
  }

  /**
   * 获取音量
   */
  getVolume() {
    return this.vhallplayer.getVolume() * 100;
  }
  /**
   * 设置音量 
   * @param {int} volume 音量 0~100
   * @param {function} failure 失败回调
   */
  setVolume(vol, failure) {
    if (typeof vol !== "number") {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    if (vol < 0 || vol > 100) {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    this.vhallplayer.setVolume(vol / 100);
  }

  /**
   * 获取当前视频总时长
   * @param {function} failure 失败回调
   */
  getDuration(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    return this.vhallplayer.getDuration();
  }

  /**
   * 获取当前视频播放时间
   * @param {function} failure 失败回调
   */
  getCurrentTime(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    return this.vhallplayer.getCurrentTime();
  }


  /**
   * 设置当前播放时间
   * @param {int} time 单位秒
   * @param {function} failure 失败回调
   */
  setCurrentTime(time, failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    if (this.vhallplayer.getSeeking()) {
      return;
    }
    this.vhallplayer.setCurrentTime(~~time || 0);
  }

  /**
   * 获取当前网络状态
   * @return {int} 0:音频/视频尚未初始化,1:音频/视频是活动的且已选取资源，但并未使用网络,2:浏览器正在下载数据,3:未找到音频/视频来源
   */
  getNetworkState() {
    return this.vhallplayer.getNetworkState();
  }


  /**
   * 销毁当前实例
   */
  destroy() {
    this.vhallplayer.destroy();
  }

  /**
   * 获取当前可选倍速 
   * @return {object} 可选倍速
   * @param {function} failure 失败回调
   */
  getUsableSpeed(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    return this.vhallplayer.playbackRateList;
  }

  /**
   * 设置倍速播放
   * @param {string} speed 倍速值
   * @param {function} failure 失败回调
   */
  setPlaySpeed(speed, failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    const playbackRateList = this.vhallplayer.playbackRateList;
    if (typeof speed !== "number") {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }

    if (playbackRateList.indexOf(speed) === -1) {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    this.vhallplayer.setPlaybackRate(speed);
  }

  /**
   * 视频截图
   */
  videoScreenshot() {
    return this.vhallplayer.capture();
  }

  /**
   * 开启弹幕
   */
  openBarrage() {
    this.vhallplayer.openBarrage();
  }

  /**
   * 关闭弹幕
   */
  closeBarrage() {
    this.vhallplayer.closeBarrage();
  }

  /**
   * 清空弹幕
   */
  clearBarrage() {
    this.vhallplayer.clearBarrage();
  }

  /**
   * 获取弹幕帧率
   * @return {string} 帧率
   */
  getBarrageFPS() {
    return this.vhallplayer.barrageFPS;
  }

  /**
   * 添加弹幕
   * @param {string} content 弹幕内容
   * @param {function} failure 失败回调
   */
  addBarrage(content, failure) {
    if (!content) {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    this.vhallplayer.addBarrage(content, 'normal');
  }

  /**
   * 设置弹幕信息
   * @param {object} opt 设置弹幕配置 {position:(0|1|2|3)  上 中 下 全屏 , alpha:(0~1) , fontsize:(int) , color:(#ffffff) }
   */
  setBarrageInfo(opt, failure) {
    if (typeof opt !== "object" && (!opt.hasOwnProperty('position') || !opt.hasOwnProperty('alpha') || !opt.hasOwnProperty('fontsize') || !opt.hasOwnProperty('color'))) {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    const { position, alpha, fontsize, color } = opt;
    typeof position === "number" && (this.vhallplayer.barragePosition = position);
    alpha && (this.vhallplayer.barrageAlpha = alpha);
    fontsize && (this.vhallplayer.barrageFontsize = fontsize);
    color && (this.vhallplayer.barrageColor = color);
  }


  /**
   * 获取播放器版本
   */
  getVersion() {
    return this.vhallplayer.version;
  }

  /**
   * 获取已下载大小
   */
  getDownloadSize() {
    return this.vhallplayer.getDownloadSize();
  }


  /**
   * 设置seek限制
   * @param {object} opt 设置seek限制所需参数
   * @param {function} failure 失败回调
   */
  setLimitSeek(opt, failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    if (typeof opt !== "object" && (!opt.hasOwnProperty('enable') || !opt.hasOwnProperty('maxTime'))) {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    if (typeof opt.enable !== "boolean" || typeof opt.maxTime !== "number") {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }

    this.isLimitSeek = opt.enable;   // 是否开启seek限制
    this.limitSeekMax = opt.maxTime;
  }

  /**
   * 打开或关闭控制条
   * @param {boolean} boolean 开启或关闭控制条
   */
  openControls(boolean) {
    this.vhallplayer.setControls(boolean);
  }


  /**
   * 打开或关闭UI
   * @param {boolean} boolean 开启或关闭UI
   */
  openUI(boolean) {
    const UI = isMobile() ? document.querySelector(".vhallPlayerh5-shadow") : document.querySelector(".vhallPlayer-container");
    boolean ? UI.classList.remove("close") : UI.classList.add("close");
  }

  /**
   * 获取当前seek限制信息
   * @param {function} failure 失败回调
   */
  getLimitSeek(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: "此方法仅点播可用", data: {} });
      return;
    }
    return { enable: this.isLimitSeek, maxTime: this.limitSeekMax };
  }


  /**
   * 重新设置大小
   * @param {object} opt 设置大小所需参数
   * @param {function} failure 失败回调
   */
  setSize(opt, failure) {
    const { width, height } = opt;
    if (!opt.hasOwnProperty("width") || !opt.hasOwnProperty("height") || typeof width !== "number" || typeof height !== "number") {
      failure && failure({ code: '611001', message: "无效的参数", data: {} });
      return;
    }
    this.vhallplayer.setSize(width, height);
  }


  /**
   * 获取当前播放器的buffered
   */
  getBuffered() {
    return this.vhallplayer.getBuffered();
  }

}